export default {"src":"/_next/static/image/public/images/ic_express_shipment.797c02c2b2af325b5813c0fbb95f87e4.gif","height":394,"width":440};